import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'mx-action-buttons',
  host: {
    class: 'flex flex-row justify-end items-center gap-x-2'
  },
  template: `
    <ng-content/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionButtonsComponent {
}
